import { AutoRefreshToogle } from "_components/buttons";
import { mapActions, /*eventsActions, filterActions, mapActions*/ } from "_store";
import { useEffect, useState } from "react";
import { useDispatch,/*, useSelector*/ 
useSelector} from "react-redux";
import { useParams } from "react-router-dom";

export { SettingsFleet };

function SettingsFleet() {

    const { flotteId } = useParams();

    const dispatch = useDispatch();
    const autoRefresh = useSelector(state => state.map.fleetAutorefresh);
    const [intervalId, setIntervalId] = useState(null);

    /* Gestion de l'autorefresh */
    const handleToogleAutoRefresh = (value) => {
        dispatch(mapActions.toggleFleetAutoRefresh(value))        
    }  

    useEffect(() => {
        // Nettoie l'intervalle à chaque fois que le composant est démonté
        return () => {
            if (intervalId) {
                dispatch(mapActions.toggleFleetAutoRefresh(false))
                clearInterval(intervalId);
                setIntervalId(null);
            }
        };
    }, [intervalId]);

    useEffect(() => {
        if (autoRefresh) {
            const id = setInterval(() => {
                dispatch(mapActions.getFleetInfo(flotteId))
            }, 120000); // 120 secondes
            setIntervalId(id);
        } else {
            // Si autoRefresh est désactivé, nettoie l'intervalle
            if (intervalId) {
                dispatch(mapActions.toggleFleetAutoRefresh(false))
                clearInterval(intervalId);
                setIntervalId(null);
            }
        }
        
        // Nettoyage sur le changement de flotteId ou autoRefresh
        return () => {
            if (intervalId) {
                dispatch(mapActions.toggleFleetAutoRefresh(false))
                clearInterval(intervalId);
                setIntervalId(null);
            }
        };
    }, [autoRefresh, flotteId, dispatch]); 


    return (
        <div className='settings-content overflow-auto'>         
            {/* RAFRAICHISSEMENT */}
            <div className="settings-title">
                <span>RAFRAICHISSEMENT</span>
            </div>
            <div className="settings-info">FLOTTE Si activé les données sont rafraichies <br/>automatiquement toutes les 2 minutes</div>
            <div className="settings-selection">
                <AutoRefreshToogle action={handleToogleAutoRefresh}/>
            </div>  
        </div>
    )
}
